import jQuery from 'jquery';
import { HpClientDebugFlags } from '../clientDebugFlags';
import { logInfo } from '../clientLogging';

const contentType = 'application/json';
type UnloadEventTypes = 'beforeunload' | 'unload';

export function sendRequestOnClose<DataT>(
  url: string,
  getData: (eventType: UnloadEventTypes) => DataT | undefined
): void {
  jQuery(window).on('beforeunload unload', (ev) => {
    const data = getData(ev.type as UnloadEventTypes);
    if (data !== undefined) {
      postEventDataSync<DataT>(url, data);
    }
  });
}

// This is required when the browser tab is closed.
function postEventDataSync<DataT>(url: string, data: DataT) {
  const jsonData = JSON.stringify(data);
  if (navigator.sendBeacon) {
    // newer browsers
    const blob = new Blob([jsonData], { type: contentType });
    navigator.sendBeacon(url, blob);
  } else {
    // older browsers (including IE11)
    jQuery.ajax({
      type: 'POST',
      url,
      async: false,
      data: jsonData,
      processData: false,
      contentType,
      success: () => {
        logInfo('completed', HpClientDebugFlags.None);
      }
    });
  }
}
